import { RootState } from 'store';

import { useSelector } from 'react-redux';

import { STATIONS_STATE } from '../../constants';

export const useStationsDisplay = () => {
  return useSelector((state: RootState) => state[STATIONS_STATE].display);
};